import { Stack } from '@mui/material'
import { C1TableRedux } from 'components/core/list/C1Table/C1TableRedux'
import List from 'components/core/list/index'
import { SelectOneAppHook } from 'components/core/search/apps'
import { sxc } from 'components/no-ui/styles/styleTypes'
import { cols } from 'components/pages/app/list/index'
import { ExportData } from 'components/pages/explore/query/ExportData'
import { StructuredSearchStyles } from 'components/pages/explore/query/styles'
import { AppValue } from 'lib/actions/apps'
import { useInitialFilters } from 'lib/search'
import { SearchAppsExpandedRequest, AppOwnersCount } from 'pbts/c1/api/app/v1/app'
import { ExportDataRequest, QueryId } from 'pbts/c1/api/exportdata/v1/exportdata'
import { FC, useCallback, useMemo, useState } from 'react'
import { appSearchApi } from 'redux_toolkit/apps'

export const AppsWithOneOwnerReport: FC = () => {
    const [page, setPage] = useState<number>(0)
    const initialFilter = useInitialFilters(SearchAppsExpandedRequest)
    const [selectedAppId, setSelectedAppId] = useState<string | undefined>(initialFilter.ids?.[0])

    const { data, isError, isLoading, getPage, canLoadMore, error } = appSearchApi.useSearchAppsExpanded(
        SearchAppsExpandedRequest.create({
            expandMask: { paths: ['*'] },
            amountOfAppOwners: AppOwnersCount.ONE_APP_OWNER,
            ids: selectedAppId ? [selectedAppId] : [],
        }),
        {},
    )

    const onPageChange = useCallback(
        async (n: number) => {
            await getPage(n)
            setPage(n)
        },
        [getPage],
    )

    const appTable = useMemo(
        () => (
            <C1TableRedux
                data={data}
                cols={cols}
                canLoadMore={canLoadMore}
                isError={isError}
                isLoading={isLoading}
                onPageChange={onPageChange}
                error={error}
                page={page}
            />
        ),
        [canLoadMore, data, error, isError, isLoading, onPageChange, page],
    )

    const exportDataActionRequest = useMemo(
        () => ExportDataRequest.create({
            queryId: QueryId.APPS_WITH_ONE_OWNER,
            request: {
                oneofKind: 'searchAppsExpandedRequest',
                searchAppsExpandedRequest: SearchAppsExpandedRequest.create({
                    expandMask: { paths: ['*'] },
                    amountOfAppOwners: AppOwnersCount.ONE_APP_OWNER,
                    ids: selectedAppId ? [selectedAppId] : [],
                }),
            },
        }),
        [selectedAppId],
    )

    const onSelect = useCallback((app:AppValue|null): void => setSelectedAppId(app?.id), [])

    return <>
        <Stack
            direction="row"
            spacing={2}
            sx={{
                justifyContent: 'space-between',
                alignItems: 'flex-end',
                pr: 1,
                pt: 1,
            }}
        >
            <SelectOneAppHook
                onSelected={onSelect}
                initAppId={initialFilter.ids?.[0]}
                sx={sxc(StructuredSearchStyles.selectApp, StructuredSearchStyles.filterInputs)}
            />
            <ExportData exportDataRequest={exportDataActionRequest} />
        </Stack>
        <List<AppValue> table={appTable} />
    </>
}
